import {useParams} from 'react-router-dom'

import {PathParamKey} from '../../definitions/routeTypes'

export function useSampleIdParameter(): string | undefined {
  return useParams<Pick<Record<PathParamKey, string>, 'sampleId'>>().sampleId
}
